import React from 'react';
import SectionHeader from '../../../components/SectionHeader';
import CapabilityItem from './CapabilityItem';
import './CapabilitiesSection.css';

interface Capability {
  icon: string;
  title: string;
  description: string;
}

interface CapabilitiesSectionProps {
  capabilities: Capability[];
}

const CapabilitiesSection: React.FC<CapabilitiesSectionProps> = ({ capabilities }) => {
  return (
    <section id="capabilities" className="capabilities-section">
      <div className="container">
        <SectionHeader
          title="What We're Capable Of"
          subtitle="From applied AI to the data platforms that power it"
        />
        <div className="capabilities-grid">
          {capabilities.map((capability, index) => (
            <CapabilityItem key={index} {...capability} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;

